@use '@/styles/tokens' as *;

.btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  border: none;
  border-radius: var(--radius-pill);
  cursor: pointer;
  transition:
    background 0.15s ease,
    transform 0.1s ease;

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }

  &:active {
    transform: scale(0.96);
  }
}

.on {
  background: $color-accent1-400;
  border: 0.5px solid $color-accent1-300;
  box-shadow:
    0 1px 1.5px rgba(224, 228, 224, 0.3),
    inset 0 1px 3px 0 #d1d4ce;
  color: #111111;

  &:hover {
    background: $color-accent1-500;
  }
}

.off {
  background: var(--surface-muted);
  color: var(--text-secondary);
  border: 1px solid var(--border-default);

  &:hover {
    background: var(--surface-subtle);
  }
}

.pending {
  opacity: 0.55;
  cursor: default;

  &:active {
    transform: none;
  }
}
